import httpWrapper from '../HttpWrapper'
import {
    GetNetworkScopedReq,
    GetNetworkScopedRes,
} from './models/getNetworkScopedDtos'
import { WorkedWithRelationshipsInfo } from './models/WorkedWithRelationshipsInfo'

class NetworkApi {
    private static instance: NetworkApi

    public constructor() {
        if (NetworkApi.instance) {
            return NetworkApi.instance
        }

        NetworkApi.instance = this
    }

    public async getWorkedWithRelationshipsInfo(): Promise<WorkedWithRelationshipsInfo> {
        return await httpWrapper.get<WorkedWithRelationshipsInfo>(
            '/network/worked-with-relationships-info',
        )
    }

    public async deleteWorkedWithRelationships(): Promise<void> {
        return await httpWrapper.post('network/delete/all-worked-with')
    }

    public async createWorkedWithRelationships(): Promise<void> {
        return await httpWrapper.post('network/create/all-worked-with')
    }

    public async getNetworkScoped(
        req: GetNetworkScopedReq,
    ): Promise<GetNetworkScopedRes> {
        return await httpWrapper.post('network/get-network-scoped', req)
    }
}

const networkApi = new NetworkApi()
export default networkApi
